// Foundation
import 'poly-eshop4/eshop/ui/js/foundation/foundation';
import 'poly-eshop4/eshop/ui/js/foundation/breakpoints';

// Foundation extensions
import 'poly-eshop4/eshop/ui/js/extensions/autofocus';
import 'poly-eshop4/eshop/ui/js/extensions/offcanvas';
import 'poly-eshop4/eshop/ui/js/extensions/map';
import 'poly-eshop4/eshop/ui/js/extensions/recaptcha';

// Stores
import 'poly-eshop4/eshop/ui/js/store/store';

// Base
import 'poly-eshop4/eshop/ui/js/confirm';
import 'poly-eshop4/eshop/ui/js/cookie';
import 'poly-eshop4/eshop/ui/js/add-to-cart';
import 'poly-eshop4/eshop/ui/js/fastentry';
import 'poly-eshop4/eshop/ui/js/cart';
import 'poly-eshop4/eshop/ui/js/checkout';
import 'poly-eshop4/eshop/ui/js/header';
import 'poly-eshop4/eshop/ui/js/items';
import 'poly-eshop4/eshop/ui/js/itemlist';
import 'poly-eshop4/eshop/ui/js/autocomplete';
import 'poly-eshop4/eshop/ui/js/search';
import 'poly-eshop4/eshop/ui/js/shoppinglist';
import 'poly-eshop4/eshop/ui/js/registration';
import 'poly-eshop4/eshop/ui/js/oci';
import 'poly-eshop4/eshop/ui/js/workaround/stickyfill';
import 'poly-eshop4/eshop/ui/js/account';
// import 'poly-eshop4/eshop/ui/js/orderapproval';
// import 'poly-eshop4/eshop/ui/js/object';
// import 'poly-eshop4/eshop/ui/js/exporter';
import 'poly-eshop4/eshop/ui/js/news';
import 'poly-eshop4/eshop/ui/js/cms';
import 'poly-eshop4/eshop/ui/js/lazyload';
import 'poly-eshop4/eshop/ui/js/statistics';
import 'poly-eshop4/eshop/ui/js/table';
// import 'poly-eshop4/eshop/ui/js/art-num-management';
// import 'poly-eshop4/eshop/ui/js/orders';
// import 'poly-eshop4/eshop/ui/js/comparisonlist';

// Payments
import 'poly-eshop4/eshop/ui/js/datatrans';

// Project JS
import './registration';

// Indiv JS
import './ariba_checkout';

// Catalog filter
$(document).on('change', '[data-itemlist-tree-filter] input', function() {
  if ($(this).closest('.autocomplete__choice-children').closest('label')
    .find('input')
    .first().length === 0) {
    $(this).closest('.autocomplete__choice-label').closest('label')
      .find('input')
      .each((idx, input) => {
        if ($(this)[0].id !== input.id) input.checked = false;
      });
  } else {
    $(this).closest('.autocomplete__choice-children').closest('label')
      .find('input')
      .first()
      .prop('checked', false);
  }
});
